import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const SilmeUyariPopup = ({
  open,
  onConfirm,
  onCancel,
  message = "Bu kaydı silmek istediğinize emin misiniz?",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          backdropFilter: "blur(18px)",
          background: "rgba(255,255,255,0.85)",
          border: "1px solid rgba(184,134,11,0.35)",
          boxShadow: "0 0 25px rgba(184,134,11,0.35)",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 700,
          color: "#b8860b",
          pb: 1,
        }}
      >
        Silme Onayı
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", pt: 2 }}>
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 500,
            color: "#5a4210",
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          pb: 3,
        }}
      >
        <Button
          onClick={onCancel}
          sx={{
            background: "#666",
            color: "#fff",
            fontWeight: 600,
            textTransform: "none",
            borderRadius: "10px",
            px: 3,
            "&:hover": { background: "#444" },
          }}
        >
          Hayır
        </Button>

        <Button
          onClick={onConfirm}
          sx={{
            background: "linear-gradient(135deg, #d4af37, #b8860b)",
            color: "#fff",
            fontWeight: 700,
            textTransform: "none",
            borderRadius: "10px",
            px: 3,
            "&:hover": {
              background: "linear-gradient(135deg, #b8860b, #8b6b0b)",
            },
          }}
        >
          Evet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SilmeUyariPopup;
